import { buildUrl } from "helpers";
import { instance } from "libs/api";

import { ApiRoutesDrivers } from "./../../constants/enums";
import { DeleteDriverResponse } from "./deleteDriver.types";

export const requestDeleteDriver = async (
  driverId: string
): Promise<DeleteDriverResponse> => {
  return await instance.delete(buildUrl(ApiRoutesDrivers.Drivers, driverId));
};
